import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import React from 'react';
import styles from './SignUp.module.scss';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../firebase';
// import { sigUpCallback } from '../../../api/auth';
import { useNavigate } from 'react-router-dom';
import localStorageService from '../../../services/localStorageService';

export const SignUp = () => {
  const navigate = useNavigate();
  
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');
    const username = data.get('username');
    const firstName = data.get('firstName');
    const lastName = data.get('lastName');
    
    try {
      if (email && password && username && firstName && lastName) {
        const user: any = await createUserWithEmailAndPassword(auth(), email.toString(), password.toString())
          .then((userCredential) => {
            return userCredential.user;
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(errorCode, errorMessage);
            return null;
          });
  
        localStorageService.setAccessToken(user?.accessToken);
        navigate('/leagues');
        // await sigUpCallback({email: email.toString(), firebaseId: user?.uid || ''});
      }
    } catch (e) {
      console.log(e);
    }
  };
  
  return (
    <div className="">
      <div className={styles.background} />
      <Box component="form" onSubmit={handleSubmit} noValidate className={styles.signUpFormContainer}>
        <span className="block text-3xl font-bold text-gray">Sign up in Hajem admin</span>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="Username"
          name="username"
          autoComplete="username"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="firstName"
          label="First name"
          name="firstName"
          autoComplete="firstName"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="lastName"
          label="Last name"
          name="lastName"
          autoComplete="lastName"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Sign In
        </Button>
        <Link href="/sign-in" variant="body2">Do you have an account? Sign in</Link>
      </Box>
    </div>
  )
}